import { Refresh } from '@mui/icons-material';
import { Alert, Snackbar } from '@mui/material';
import { VersionContext } from 'lib/context/VersionProvider';
import React, { useContext, useEffect, useState } from 'react';

export const VersionBanner = () => {
  const { isNewVersionAvailable, setIsNewVersionAvailable } =
    useContext(VersionContext);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isNewVersionAvailable && !open) {
      setOpen(true);
    }
  }, [isNewVersionAvailable]);

  const handleClick = () => {
    setIsNewVersionAvailable(false);
    window.location.reload();
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      onClick={handleClick}
      sx={{
        cursor: 'pointer',
      }}
    >
      <Alert
        severity="success"
        variant="filled"
        sx={{ width: '100%' }}
        icon={<Refresh />}
      >
        Nueva versión disponible. Click para actualizar.
      </Alert>
    </Snackbar>
  );
};
